import { AUTH_TOKEN_KEY } from "../Constant";

let inMemoryToken: string | null = null;

export const tokenManager = {
  setToken: (token: string | null) => {
    inMemoryToken = token;
    if (token) {
      localStorage.setItem(AUTH_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(AUTH_TOKEN_KEY);
    }
  },

  getToken: (): string | null => {
    if (inMemoryToken) {
      return inMemoryToken;
    }
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) {
      inMemoryToken = token;
    }
    return inMemoryToken;
  },

  clearToken: () => {
    inMemoryToken = null;
    localStorage.removeItem(AUTH_TOKEN_KEY);
  },
};
